import { useCallback, useEffect, useRef, useState } from 'react';
import { startJob, waitForJob } from './managementApi';

// status is one of: idle, running, succeeded, failed
const useManagementAction = (endpoint) => {
    const [state, setState] = useState({ status: 'idle', message: null, error: null, startedAt: null });
    const cancelled = useRef(false);

    useEffect(() => {
        cancelled.current = false;
        return () => {
            cancelled.current = true;
        };
    }, []);

    const run = useCallback(
        async (body) => {
            setState({ status: 'running', message: null, error: null, startedAt: Date.now() });

            try {
                const job = await startJob(endpoint, body);
                const finished = job.state === 'running'
                    ? await waitForJob(job.id, { isCancelled: () => cancelled.current })
                    : job;
                if (!finished || cancelled.current) return;

                setState((prev) => ({
                    ...prev,
                    status: finished.state === 'succeeded' ? 'succeeded' : 'failed',
                    message: finished.message,
                    error: finished.error,
                }));
            } catch (err) {
                if (!cancelled.current) {
                    setState((prev) => ({ ...prev, status: 'failed', message: null, error: err.message }));
                }
            }
        },
        [endpoint]
    );

    return { ...state, running: state.status === 'running', run };
};

export default useManagementAction;
